import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

import { routes } from "../Routes/Routes";

export default class Content extends Component {
  render() {
    return (
      <div>
        <Switch>
          {routes.map((route, idx) => {
            return route.component ? (
              <Route
                key={idx}
                path={route.path}
                exact={route.exact}
                name={route.name}
                render={props => <route.component {...props} />}
              />
            ) : null;
          })}
        </Switch>
      </div>
    );
  }
}
